import apiUrl from './api';
import { postWithAuth } from '@/lib/httpAdapter';

// Request/Response Types
export interface FetchUserAPIKeyRequest {
  UserUUID: string;
}

export interface FetchUserAPIKeyResponse {
  ApiKey?: string;
  CreatedAt?: string | null;
  Error?: string | null;
}

export interface GenerateAPIKeyRequest {
  UserUUID: string;
}

export interface GenerateAPIKeyResponse {
  ApiKey?: string;
  CreatedAt?: string | null;
  Error?: string | null;
}

export interface DeleteApiKeyRequest {
  UserUUID: string;
}

export interface DeleteApiKeyResponse {
  Success: boolean;
  Error?: string;
}

// API Functions
export async function fetchUserAPIKey(
  request: FetchUserAPIKeyRequest
): Promise<FetchUserAPIKeyResponse> {
  const url = `${apiUrl}fetchUserAPIKey/`;

  try {
    const response = await postWithAuth(url, request, {
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error(`Failed to fetch API key: ${response.statusText}`);
    }

    let data = await response.json();

    // Handle case where response might be double-stringified
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) {
        throw new Error('Failed to parse response as JSON');
      }
    }

    return data;
  } catch (error) {
    console.error('Error in fetchUserAPIKey:', error);
    throw error;
  }
}

export async function generateAPIKey(
  request: GenerateAPIKeyRequest
): Promise<GenerateAPIKeyResponse> {
  const url = `${apiUrl}generateAPIKey/`;

  try {
    const response = await postWithAuth(url, request, {
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error(`Failed to generate API key: ${response.statusText}`);
    }

    let data = await response.json();

    // Handle case where response might be double-stringified
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) {
        throw new Error('Failed to parse response as JSON');
      }
    }

    return data;
  } catch (error) {
    console.error('Error in generateAPIKey:', error);
    throw error;
  }
}

export async function deleteApiKey(
  request: DeleteApiKeyRequest
): Promise<DeleteApiKeyResponse> {
  const url = `${apiUrl}deleteAPIKey/`;

  try {
    const response = await postWithAuth(url, request, {
      headers: {
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
      },
    });
    let responseData = await response.json();

    // Handle case where response might be double-stringified
    if (typeof responseData === 'string') {
      try {
        responseData = JSON.parse(responseData);
      } catch (e) {
        throw new Error('Failed to parse response as JSON');
      }
    }

    if (!response.ok) {
      throw new Error(`Failed to delete API key: ${response.statusText}`);
    }

    return responseData;
  } catch (error) {
    console.error('Error in deleteApiKey:', error);
    throw error;
  }
}
